/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AvailabilityByProduct,
  QuerySortCriterionSalesOrderItemAvailabilitiesQuery,
  SalesOrderItemAvailabilitySummary,
  SalesOrderItemAvailabilitySummaryResponse,
  SalesOrderItemAvailabilityTotalSummary,
  SortDirection,
} from '../models/index';
import {
    AvailabilityByProductFromJSON,
    AvailabilityByProductToJSON,
    QuerySortCriterionSalesOrderItemAvailabilitiesQueryFromJSON,
    QuerySortCriterionSalesOrderItemAvailabilitiesQueryToJSON,
    SalesOrderItemAvailabilitySummaryFromJSON,
    SalesOrderItemAvailabilitySummaryToJSON,
    SalesOrderItemAvailabilitySummaryResponseFromJSON,
    SalesOrderItemAvailabilitySummaryResponseToJSON,
    SalesOrderItemAvailabilityTotalSummaryFromJSON,
    SalesOrderItemAvailabilityTotalSummaryToJSON,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/index';

export interface GetSalesOrderItemAvailabilitySummariesOfCurrentRetailerRequest {
    offset?: number;
    limit?: number;
    sortByCustomerOrderNumber?: SortDirection;
    sortBySalesOrderCreatedAt?: SortDirection;
    sortBySalesOrderItemAvailability?: SortDirection;
    sortByProductNumber?: SortDirection;
    sortByProductManufacturer?: SortDirection;
    sortByProductType?: SortDirection;
    sortByQuantity?: SortDirection;
    sortByAvailabilityStatus?: SortDirection;
    sortBySalesOrderItemPricePerUnit?: SortDirection;
    sortBySalesOrderItemDiscountedPricePerUnit?: SortDirection;
    sortBySalesOrderItemTotal?: SortDirection;
    sortByCustomerItemReference?: SortDirection;
    sortByCustomerReference?: SortDirection;
    sortByGtin?: SortDirection;
    sortByInfoToCustomer?: SortDirection;
    fulltextQuery?: string;
    productManufacturers?: Array<string>;
    productTypes?: Array<string>;
    status?: Array<GetSalesOrderItemAvailabilitySummariesOfCurrentRetailerStatusEnum>;
    createdBetweenFrom?: Date;
    createdBetweenUntil?: Date;
    availableBetweenFrom?: Date;
    availableBetweenUntil?: Date;
    sortCriteria?: Set<QuerySortCriterionSalesOrderItemAvailabilitiesQuery>;
}

export interface GetSalesOrderItemAvailabilitySummariesOfCurrentRetailerCsvExportRequest {
    sortByCustomerOrderNumber?: SortDirection;
    sortBySalesOrderCreatedAt?: SortDirection;
    sortBySalesOrderItemAvailability?: SortDirection;
    sortByProductNumber?: SortDirection;
    sortByProductManufacturer?: SortDirection;
    sortByProductType?: SortDirection;
    sortByQuantity?: SortDirection;
    sortByAvailabilityStatus?: SortDirection;
    sortBySalesOrderItemPricePerUnit?: SortDirection;
    sortBySalesOrderItemDiscountedPricePerUnit?: SortDirection;
    sortBySalesOrderItemTotal?: SortDirection;
    sortByCustomerItemReference?: SortDirection;
    sortByCustomerReference?: SortDirection;
    fulltextQuery?: string;
    productManufacturers?: Array<string>;
    productTypes?: Array<string>;
    status?: Array<GetSalesOrderItemAvailabilitySummariesOfCurrentRetailerCsvExportStatusEnum>;
    createdBetweenFrom?: Date;
    createdBetweenUntil?: Date;
    availableBetweenFrom?: Date;
    availableBetweenUntil?: Date;
    sortCriteria?: Set<QuerySortCriterionSalesOrderItemAvailabilitiesQuery>;
}

export interface GetSalesOrderItemProductSummariesOfCurrentRetailerRequest {
    productNumbers: Array<string>;
}

/**
 * 
 */
export class SalesOrderItemAvailabilityResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getSalesOrderItemAvailabilitySummariesOfCurrentRetailer without sending the request
     */
    async getSalesOrderItemAvailabilitySummariesOfCurrentRetailerRequestOpts(requestParameters: GetSalesOrderItemAvailabilitySummariesOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sortByCustomerOrderNumber'] != null) {
            queryParameters['sortByCustomerOrderNumber'] = requestParameters['sortByCustomerOrderNumber'];
        }

        if (requestParameters['sortBySalesOrderCreatedAt'] != null) {
            queryParameters['sortBySalesOrderCreatedAt'] = requestParameters['sortBySalesOrderCreatedAt'];
        }

        if (requestParameters['sortBySalesOrderItemAvailability'] != null) {
            queryParameters['sortBySalesOrderItemAvailability'] = requestParameters['sortBySalesOrderItemAvailability'];
        }

        if (requestParameters['sortByProductNumber'] != null) {
            queryParameters['sortByProductNumber'] = requestParameters['sortByProductNumber'];
        }

        if (requestParameters['sortByProductManufacturer'] != null) {
            queryParameters['sortByProductManufacturer'] = requestParameters['sortByProductManufacturer'];
        }

        if (requestParameters['sortByProductType'] != null) {
            queryParameters['sortByProductType'] = requestParameters['sortByProductType'];
        }

        if (requestParameters['sortByQuantity'] != null) {
            queryParameters['sortByQuantity'] = requestParameters['sortByQuantity'];
        }

        if (requestParameters['sortByAvailabilityStatus'] != null) {
            queryParameters['sortByAvailabilityStatus'] = requestParameters['sortByAvailabilityStatus'];
        }

        if (requestParameters['sortBySalesOrderItemPricePerUnit'] != null) {
            queryParameters['sortBySalesOrderItemPricePerUnit'] = requestParameters['sortBySalesOrderItemPricePerUnit'];
        }

        if (requestParameters['sortBySalesOrderItemDiscountedPricePerUnit'] != null) {
            queryParameters['sortBySalesOrderItemDiscountedPricePerUnit'] = requestParameters['sortBySalesOrderItemDiscountedPricePerUnit'];
        }

        if (requestParameters['sortBySalesOrderItemTotal'] != null) {
            queryParameters['sortBySalesOrderItemTotal'] = requestParameters['sortBySalesOrderItemTotal'];
        }

        if (requestParameters['sortByCustomerItemReference'] != null) {
            queryParameters['sortByCustomerItemReference'] = requestParameters['sortByCustomerItemReference'];
        }

        if (requestParameters['sortByCustomerReference'] != null) {
            queryParameters['sortByCustomerReference'] = requestParameters['sortByCustomerReference'];
        }

        if (requestParameters['sortByGtin'] != null) {
            queryParameters['sortByGtin'] = requestParameters['sortByGtin'];
        }

        if (requestParameters['sortByInfoToCustomer'] != null) {
            queryParameters['sortByInfoToCustomer'] = requestParameters['sortByInfoToCustomer'];
        }

        if (requestParameters['fulltextQuery'] != null) {
            queryParameters['fulltextQuery'] = requestParameters['fulltextQuery'];
        }

        if (requestParameters['productManufacturers'] != null) {
            queryParameters['productManufacturers'] = requestParameters['productManufacturers'];
        }

        if (requestParameters['productTypes'] != null) {
            queryParameters['productTypes'] = requestParameters['productTypes'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['createdBetweenFrom'] != null) {
            queryParameters['createdBetweenFrom'] = (requestParameters['createdBetweenFrom'] as any).toISOString();
        }

        if (requestParameters['createdBetweenUntil'] != null) {
            queryParameters['createdBetweenUntil'] = (requestParameters['createdBetweenUntil'] as any).toISOString();
        }

        if (requestParameters['availableBetweenFrom'] != null) {
            queryParameters['availableBetweenFrom'] = (requestParameters['availableBetweenFrom'] as any).toISOString();
        }

        if (requestParameters['availableBetweenUntil'] != null) {
            queryParameters['availableBetweenUntil'] = (requestParameters['availableBetweenUntil'] as any).toISOString();
        }

        if (requestParameters['sortCriteria'] != null) {
            queryParameters['sortCriteria'] = requestParameters['sortCriteria'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/sales-order-item-availability/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getSalesOrderItemAvailabilitySummariesOfCurrentRetailerRaw(requestParameters: GetSalesOrderItemAvailabilitySummariesOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SalesOrderItemAvailabilitySummaryResponse>> {
        const requestOptions = await this.getSalesOrderItemAvailabilitySummariesOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SalesOrderItemAvailabilitySummaryResponseFromJSON(jsonValue));
    }

    /**
     */
    async getSalesOrderItemAvailabilitySummariesOfCurrentRetailer(requestParameters: GetSalesOrderItemAvailabilitySummariesOfCurrentRetailerRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SalesOrderItemAvailabilitySummaryResponse> {
        const response = await this.getSalesOrderItemAvailabilitySummariesOfCurrentRetailerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSalesOrderItemAvailabilitySummariesOfCurrentRetailerCsvExport without sending the request
     */
    async getSalesOrderItemAvailabilitySummariesOfCurrentRetailerCsvExportRequestOpts(requestParameters: GetSalesOrderItemAvailabilitySummariesOfCurrentRetailerCsvExportRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['sortByCustomerOrderNumber'] != null) {
            queryParameters['sortByCustomerOrderNumber'] = requestParameters['sortByCustomerOrderNumber'];
        }

        if (requestParameters['sortBySalesOrderCreatedAt'] != null) {
            queryParameters['sortBySalesOrderCreatedAt'] = requestParameters['sortBySalesOrderCreatedAt'];
        }

        if (requestParameters['sortBySalesOrderItemAvailability'] != null) {
            queryParameters['sortBySalesOrderItemAvailability'] = requestParameters['sortBySalesOrderItemAvailability'];
        }

        if (requestParameters['sortByProductNumber'] != null) {
            queryParameters['sortByProductNumber'] = requestParameters['sortByProductNumber'];
        }

        if (requestParameters['sortByProductManufacturer'] != null) {
            queryParameters['sortByProductManufacturer'] = requestParameters['sortByProductManufacturer'];
        }

        if (requestParameters['sortByProductType'] != null) {
            queryParameters['sortByProductType'] = requestParameters['sortByProductType'];
        }

        if (requestParameters['sortByQuantity'] != null) {
            queryParameters['sortByQuantity'] = requestParameters['sortByQuantity'];
        }

        if (requestParameters['sortByAvailabilityStatus'] != null) {
            queryParameters['sortByAvailabilityStatus'] = requestParameters['sortByAvailabilityStatus'];
        }

        if (requestParameters['sortBySalesOrderItemPricePerUnit'] != null) {
            queryParameters['sortBySalesOrderItemPricePerUnit'] = requestParameters['sortBySalesOrderItemPricePerUnit'];
        }

        if (requestParameters['sortBySalesOrderItemDiscountedPricePerUnit'] != null) {
            queryParameters['sortBySalesOrderItemDiscountedPricePerUnit'] = requestParameters['sortBySalesOrderItemDiscountedPricePerUnit'];
        }

        if (requestParameters['sortBySalesOrderItemTotal'] != null) {
            queryParameters['sortBySalesOrderItemTotal'] = requestParameters['sortBySalesOrderItemTotal'];
        }

        if (requestParameters['sortByCustomerItemReference'] != null) {
            queryParameters['sortByCustomerItemReference'] = requestParameters['sortByCustomerItemReference'];
        }

        if (requestParameters['sortByCustomerReference'] != null) {
            queryParameters['sortByCustomerReference'] = requestParameters['sortByCustomerReference'];
        }

        if (requestParameters['fulltextQuery'] != null) {
            queryParameters['fulltextQuery'] = requestParameters['fulltextQuery'];
        }

        if (requestParameters['productManufacturers'] != null) {
            queryParameters['productManufacturers'] = requestParameters['productManufacturers'];
        }

        if (requestParameters['productTypes'] != null) {
            queryParameters['productTypes'] = requestParameters['productTypes'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['createdBetweenFrom'] != null) {
            queryParameters['createdBetweenFrom'] = (requestParameters['createdBetweenFrom'] as any).toISOString();
        }

        if (requestParameters['createdBetweenUntil'] != null) {
            queryParameters['createdBetweenUntil'] = (requestParameters['createdBetweenUntil'] as any).toISOString();
        }

        if (requestParameters['availableBetweenFrom'] != null) {
            queryParameters['availableBetweenFrom'] = (requestParameters['availableBetweenFrom'] as any).toISOString();
        }

        if (requestParameters['availableBetweenUntil'] != null) {
            queryParameters['availableBetweenUntil'] = (requestParameters['availableBetweenUntil'] as any).toISOString();
        }

        if (requestParameters['sortCriteria'] != null) {
            queryParameters['sortCriteria'] = requestParameters['sortCriteria'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/sales-order-item-availability/export-csv`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getSalesOrderItemAvailabilitySummariesOfCurrentRetailerCsvExportRaw(requestParameters: GetSalesOrderItemAvailabilitySummariesOfCurrentRetailerCsvExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SalesOrderItemAvailabilitySummary>>> {
        const requestOptions = await this.getSalesOrderItemAvailabilitySummariesOfCurrentRetailerCsvExportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SalesOrderItemAvailabilitySummaryFromJSON));
    }

    /**
     */
    async getSalesOrderItemAvailabilitySummariesOfCurrentRetailerCsvExport(requestParameters: GetSalesOrderItemAvailabilitySummariesOfCurrentRetailerCsvExportRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SalesOrderItemAvailabilitySummary>> {
        const response = await this.getSalesOrderItemAvailabilitySummariesOfCurrentRetailerCsvExportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSalesOrderItemAvailabilityTotalOfCurrentRetailer without sending the request
     */
    async getSalesOrderItemAvailabilityTotalOfCurrentRetailerRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/sales-order-item-availability/total`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getSalesOrderItemAvailabilityTotalOfCurrentRetailerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SalesOrderItemAvailabilityTotalSummary>>> {
        const requestOptions = await this.getSalesOrderItemAvailabilityTotalOfCurrentRetailerRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SalesOrderItemAvailabilityTotalSummaryFromJSON));
    }

    /**
     */
    async getSalesOrderItemAvailabilityTotalOfCurrentRetailer(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SalesOrderItemAvailabilityTotalSummary>> {
        const response = await this.getSalesOrderItemAvailabilityTotalOfCurrentRetailerRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSalesOrderItemProductSummariesOfCurrentRetailer without sending the request
     */
    async getSalesOrderItemProductSummariesOfCurrentRetailerRequestOpts(requestParameters: GetSalesOrderItemProductSummariesOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['productNumbers'] == null) {
            throw new runtime.RequiredError(
                'productNumbers',
                'Required parameter "productNumbers" was null or undefined when calling getSalesOrderItemProductSummariesOfCurrentRetailer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['productNumbers'] != null) {
            queryParameters['productNumbers'] = requestParameters['productNumbers'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/sales-order-item-availability/product`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getSalesOrderItemProductSummariesOfCurrentRetailerRaw(requestParameters: GetSalesOrderItemProductSummariesOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AvailabilityByProduct>>> {
        const requestOptions = await this.getSalesOrderItemProductSummariesOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AvailabilityByProductFromJSON));
    }

    /**
     */
    async getSalesOrderItemProductSummariesOfCurrentRetailer(requestParameters: GetSalesOrderItemProductSummariesOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AvailabilityByProduct>> {
        const response = await this.getSalesOrderItemProductSummariesOfCurrentRetailerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetSalesOrderItemAvailabilitySummariesOfCurrentRetailerStatusEnum = {
    InStock: 'IN_STOCK',
    InStockOverdue: 'IN_STOCK_OVERDUE',
    InStockNotReleased: 'IN_STOCK_NOT_RELEASED',
    Incoming: 'INCOMING',
    InPreorder: 'IN_PREORDER',
    OnRequest: 'ON_REQUEST'
} as const;
export type GetSalesOrderItemAvailabilitySummariesOfCurrentRetailerStatusEnum = typeof GetSalesOrderItemAvailabilitySummariesOfCurrentRetailerStatusEnum[keyof typeof GetSalesOrderItemAvailabilitySummariesOfCurrentRetailerStatusEnum];
/**
 * @export
 */
export const GetSalesOrderItemAvailabilitySummariesOfCurrentRetailerCsvExportStatusEnum = {
    InStock: 'IN_STOCK',
    InStockOverdue: 'IN_STOCK_OVERDUE',
    InStockNotReleased: 'IN_STOCK_NOT_RELEASED',
    Incoming: 'INCOMING',
    InPreorder: 'IN_PREORDER',
    OnRequest: 'ON_REQUEST'
} as const;
export type GetSalesOrderItemAvailabilitySummariesOfCurrentRetailerCsvExportStatusEnum = typeof GetSalesOrderItemAvailabilitySummariesOfCurrentRetailerCsvExportStatusEnum[keyof typeof GetSalesOrderItemAvailabilitySummariesOfCurrentRetailerCsvExportStatusEnum];
